import * as React from 'react';

import { cn } from 'src/shared/helpers/utils';

type InputRoundness = 'Default' | 'Round';

interface InputProps extends React.ComponentProps<'input'> {
    roundness?: InputRoundness;
}

const inputRoundnessClasses: Record<InputRoundness, string> = {
    Default: 'rounded-md',
    Round: 'rounded-full',
};

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, roundness = 'Default', ...props }, ref) => {
    return (
        <input
            type={type}
            className={cn(
                'flex h-10 w-full border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
                inputRoundnessClasses[roundness],
                className
            )}
            ref={ref}
            {...props}
        />
    );
});
Input.displayName = 'Input';

export { Input };
